<template>
  <Modal>
    <Modal.Title>
      <span class="flex items-center gap-2 text-red-700">
        <AlertIcon class="size-[22px] text-red-700" />
        {{ header }}
      </span>
    </Modal.Title>
    <Modal.Body>{{ message }}</Modal.Body>
    <Modal.Footer>
      <Button
        variant="danger"
        :size="isMobile ? 'lg' : 'md'"
        @click="close()"
      >
        Okay
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'
import { analytics } from '@/shared/services/analytics'
import { useDevice } from '@/shared/composables/useDevice'

const props = defineProps<{
  title?: string
  content?: string
  error?: Error
}>()

const { close } = useModal()
const { isMobile } = useDevice()

const header = computed(() => props.title || 'Something went wrong')
const message = computed(
  () => props.content || 'We encountered an error. Please try again later.'
)

onMounted(() => {
  if (props.error) {
    analytics.captureException(
      props.error instanceof Error
        ? props.error
        : new Error(String(props.error))
    )
  }
})
</script>
